exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loader-overlay_root_1RE {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background: rgba(226, 225, 224, 0.5);\n  z-index: 100; }\n", "", {"version":3,"sources":["/Users/nicolaythafvelin/efoil/logger-webapp/src/ui/loader/loader-overlay.scss"],"names":[],"mappings":"AAIA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,aAAa,EAAE","file":"loader-overlay.scss","sourcesContent":[":export {\n  primaryColor: #00bcd4;\n  accentColor: #ff5722; }\n\n.root {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background: rgba(226, 225, 224, 0.5);\n  z-index: 100; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"primaryColor": "#00bcd4",
	"accentColor": "#ff5722",
	"root": "loader-overlay_root_1RE"
};